// Open (consumer) invitation links.
import { apiFetch } from '../lib/api';

// Mint a fresh single-use open link. Returns { id, token, path, expires_at, ... }.
export async function createOpenLink() {
  const res = await apiFetch('/v1/invitations/link', { method: 'POST', body: {} });
  return res.link;
}

// Public preview (no auth). Open links return { invite_kind:'open', inviter:{ first_name }, ... }.
export async function getInvitationPreview(token) {
  return apiFetch(`/v1/invitations/accept/${token}`, { auth: false });
}

// Accept (JWT required). Open links return { connection_id, inviter:{ first_name } }.
export async function acceptInvitation(token) {
  return apiFetch(`/v1/invitations/accept/${token}`, { method: 'POST' });
}

// Full shareable URL for a minted link path (e.g. /i/<token>).
export function shareUrl(path) {
  return `${window.location.origin}${path}`;
}
